export default {
	share_add_users: 'Personen oder Gruppen hinzufügen',
	share_chain_show_less: 'Weniger anzeigen',
	share_chain_show_more: 'Alle anzeigen',
	share_chain_write_message: 'Nachricht schreiben',
	share_chip_shared_by: 'Geteilt von {name}',
	share_dialog_close: 'Übernehmen',
	share_message_label: 'Nachricht an die Empfänger (optional)',
	share_not_shared: 'Nicht geteilt',
	share_remove_user: '{name} entfernen',
	share_reshared: 'Mit dir geteilt & weitergeteilt',
	share_shared: 'Geteilt',
	share_shared_by_others: 'Von anderen geteilt',
	share_shared_by_you: 'Von dir geteilt',
	share_sharing: 'Teilen',
	share_sheet_change_added: '{n} hinzugefügt',
	share_sheet_change_message: 'Nachricht geändert',
	share_sheet_change_removed: '{n} entfernt',
	share_sheet_discard: 'Verwerfen',
	share_sheet_discard_message: 'Nicht gespeichert werden: {changes}.',
	share_sheet_discard_title: 'Änderungen verwerfen?',
	share_sheet_edit_message: 'Nachricht bearbeiten',
	share_sheet_folded_unfold: 'Nachricht anzeigen',
	share_sheet_group_member_count: '{n} Person | {n} Personen',
	share_sheet_keep_editing: 'Weiter bearbeiten',
	share_sheet_message_heading: 'Nachricht an die Empfänger',
	share_sheet_message_placeholder: 'Nachricht hinzufügen (optional)',
	share_sheet_row_new: 'Neu',
	share_sheet_search_no_results: 'Keine Personen oder Gruppen gefunden',
	share_sheet_search_placeholder: 'Personen oder Gruppen suchen',
	share_sheet_section_groups: 'Gruppen',
	share_sheet_section_people: 'Personen',
	share_sheet_section_selected: 'Ausgewählt',
	share_sheet_title: 'Teilen: {title}',
	share_status_ready: 'Erledigt',
	share_status_seen: 'In Bearbeitung',
	share_status_unseen: 'Ungesichtet',
};
